import { memo, ReactNode, useState } from "react";

import { ModalComponent } from "@zenith/components";
import { AppNavigation } from "@zenith/hooks";
import { SETTINGS } from "@zenith/routes/paths";

interface FinishRegistrationModalProps {
  show: boolean;
  onClose?: () => void;
}

const FinishRegistrationModal = memo(function FinishRegistrationModal({
  show,
  onClose,
}: FinishRegistrationModalProps): JSX.Element | null {
  const { navigateTo } = AppNavigation();

  const handleSettingsNavigation = () => {
    navigateTo(SETTINGS);
  };

  const handleFinishRegistrationModal = () => {
    if (onClose) onClose();
  };

  return show ? (
    <ModalComponent
      body="Complete your profile registration in the app settings to unlock transactions and maximize our services."
      title="Finish Your Registration"
      showErrorIcon={true}
      showModal={show}
      onClickClose={handleFinishRegistrationModal}
      doubleOptions={true}
      onLeftButtonClick={handleFinishRegistrationModal}
      onRightButtonClick={handleSettingsNavigation}
      leftButtonText="Later"
      rightButtonText="Go to Settings"
      classNames="!rounded-2.5xl"
    />
  ) : null;
});

// hook to control the modal state
interface UseFinishRegistrationModalResult {
  openFinishRegistrationModal: () => void;
  closeFinishRegistrationModal: () => void;
  finishRegistrationModal: ReactNode;
}

function useFinishRegistrationModal(): UseFinishRegistrationModalResult {
  const [showModal, setShowModal] = useState<boolean>(false);

  const openFinishRegistrationModal = () => setShowModal(true);
  const closeFinishRegistrationModal = () => setShowModal(false);

  const finishRegistrationModal = (
    <FinishRegistrationModal
      show={showModal}
      onClose={closeFinishRegistrationModal}
    />
  );

  return {
    openFinishRegistrationModal,
    closeFinishRegistrationModal,
    finishRegistrationModal,
  };
}

export default FinishRegistrationModal;
export { useFinishRegistrationModal };
